import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/yom.webp';
import screenshot_target from '../../../images/letterfunnel/jorritvelzeboer.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jorrit Velzeboer"
      firstname="Jorrit"
      companyname="YOM"
      competition="Aethir en PureWeb"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jorritvelzeboer.js